import React from "react";
import { Modal as RSModal } from "reactstrap";
import "./index.scss";

export default class Modal extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    let {
      isOpen,
      onClose,
      modalClassName,
      shouldCloseOnOverlayClick = true,
      title,
      children,
    } = this.props;
    return (
      <RSModal {...this.props}>
        <div className="inner-content">
          {title && (
            <div className="modal-header flex center">
              <h2>{title}</h2>
            </div>
          )}
          <div className="section-container col">{children}</div>
        </div>
      </RSModal>
    );
  }
}
